import { isHeicLikeMimeType, isHeicLikePath } from './asset-preview';

function isHeicFile(file: File): boolean {
  if (isHeicLikeMimeType(file.type)) return true;
  if (isHeicLikePath(file.name)) return true;
  // Chrome/Firefox report HEIC as empty string or application/octet-stream
  if (!file.type || file.type === 'application/octet-stream') {
    return /\.hei[cf]$/i.test(file.name);
  }
  return false;
}

export async function convertHeicToJpeg(file: File): Promise<File> {
  if (!isHeicFile(file)) return file;

  const { default: heic2any } = await import('heic2any');
  const blob = await heic2any({ blob: file, toType: 'image/jpeg', quality: 0.92 });
  const result = Array.isArray(blob) ? blob[0] : blob;
  const newName = file.name.replace(/\.hei[cf]$/i, '.jpg');
  return new File([result], newName, { type: 'image/jpeg' });
}
